<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 99999">
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      class="toast show align-items-center text-white border-0 mb-2"
      [class.bg-danger]="toast.type === 'error'"
      [class.bg-success]="toast.type === 'success'"
      [class.bg-warning]="toast.type === 'warning'"
      [class.bg-info]="toast.type === 'info'"
      role="alert"
    >
      <div class="d-flex">
        <div class="toast-body">
          @let groups = toast.message.split('\n\n');
          @if (groups.length > 1 || toast.message.includes('\n')) {
            <ul class="toast-message-list">
              @for (group of groups; track $index) {
                @let subLines = group.split('\n• ');
                <li>
                  @if (subLines.length > 1) {
                    <div class="toast-field-label">{{ subLines[0] }}</div>
                    <ul class="toast-sub-message-list">
                      @for (subLine of subLines.slice(1); track $index) {
                        <li>{{ subLine }}</li>
                      }
                    </ul>
                  } @else if (group.includes('\n')) {
                    <ul class="toast-sub-message-list">
                      @for (line of group.split('\n'); track $index) {
                        <li>{{ line }}</li>
                      }
                    </ul>
                  } @else {
                    {{ group }}
                  }
                </li>
              }
            </ul>
          } @else {
            {{ toast.message }}
          }
        </div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          (click)="toastService.remove(toast.id)"
        ></button>
      </div>
    </div>
  }
</div>
